import * as React from 'react';
import * as classnames from 'classnames';
import { ButtonGroup, Button } from '@salesforce/design-system-react';
import './view-buttons.css';

interface ViewButtonsProps {
	list?: boolean;
}

const ViewButtons: React.SFC<ViewButtonsProps> = ({ list }) => (
	<ButtonGroup>
		<Button
			className={classnames('button_list', {'slds-button_icon-brand': list})}
			iconName="list"
			iconVariant={list ? 'bare' : 'border-filled'}
			variant="icon"
		/>
		<Button
			className={list ? '' : 'slds-button_icon-brand'}
			iconVariant={list ? 'border-filled' : 'bare'}
			variant="icon"
		>
			<span className="icon__constellation" />
		</Button>
	</ButtonGroup>
);

export default ViewButtons;


// WEBPACK FOOTER //
// ./src/DataSources/ViewButtons.tsx